import * as actionType from "../types/ActionTypes";

const initialState = {
  courses: [],
  postCourses: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Courses = (state = initialState, action) => {
  switch (action.type) {
    case actionType.COURSES_SET_DATA:
      return {
        ...state,
        courses: action.courses,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.COURSES_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.COURSES_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.COURSES_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.COURSES_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_COURSES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_COURSES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postCourses: action.postCourses,
      };
    case actionType.UPDATE_COURSES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_COURSES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_COURSES_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
